import type {
    IEdgeRegistration,
    IEdgeRegistrationFormDto,
} from '@experiences/interfaces';

import {
    axiosDelete,
    get,
    post,
} from '../utility/Requests';

const getHeaders = (selectedTenantId: string, selectedAccountId: string) => ({
    extendRequestHeaders: 'true',
    'X-UiPath-Internal-TenantId': selectedTenantId,
    'X-UiPath-Internal-AccountId': selectedAccountId,
});

const FRP_URL = '/api/frp';

export async function getEdgeRegistration({
    accountId, tenantId,
}: {
    accountId: string;
    tenantId: string;
}) {
    try {
        const response = await get<IEdgeRegistration>(FRP_URL, { headers: getHeaders(tenantId, accountId) });
        return [ response ];
    } catch (error: any) {
        // Handle 404 - no edge registrations found, return empty array
        if (error?.response?.status === 404 || error?.status === 404) {
            return [];
        }
        // Re-throw other errors
        throw error;
    }
}

export async function registerEdge(
    accountId: string,
    tenantId: string,
    data: IEdgeRegistrationFormDto) {

    const formData = new FormData();
    formData.append('customDomain', data.customDomain);
    formData.append('cidr', data.cidr);
    formData.append('kubeconfigFile', data.kubeconfigFile as Blob);

    return await post<IEdgeRegistration>(FRP_URL,
        {
            body: formData,
            isFormData: true,
            headers: {
                'Content-Type': 'multipart/form-data',
                ...getHeaders(tenantId, accountId),
            },
        });
}

export function deleteEdgeRegistration(accountId: string, tenantId: string, edgeId: string) {
    return axiosDelete(`${FRP_URL}/edge/${edgeId}`, { headers: getHeaders(tenantId, accountId) });
}
